import { UserList } from 'ui/shared';
import { Popover } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';

const StudentsGradesDropdownMenu = ({ users, open, anchorEl, onClose, isScore, scoreScale, evaluationScale }) => {
  return (
    <div className="dropdown-students-grades">
      <Popover open={open} anchorEl={anchorEl} handleClose={onClose} className="dropdown-students-grades__lib">
        <div className="dropdown-students-grades__dropdown">
          <UserList
            evaluationScale={evaluationScale}
            users={users}
            showNote={true}
            showPoints={false}
            showCheckbox={false}
            isScore={isScore}
            withBorder={true}
            scoreScale={scoreScale}
          />
        </div>
      </Popover>
    </div>
  );
};

StudentsGradesDropdownMenu.propTypes = {
  anchorEl: PropTypes.object,
  evaluationScale: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  isScore: PropTypes.bool,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  scoreScale: PropTypes.number,
  users: PropTypes.array,
};

StudentsGradesDropdownMenu.defaultProps = {
  open: false,
  users: [],
  onClose: () => {},
  anchorEl: {},
  isScore: true,
};

export default StudentsGradesDropdownMenu;
